/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/admin/__root'
import { Route as IndexRouteImport } from './routes/admin/index'
import { Route as ApprovalsRouteImport } from './routes/admin/approvals'
import { Route as BookingsRouteImport } from './routes/admin/bookings'
import { Route as ContentRouteImport } from './routes/admin/content'
import { Route as FinanceRouteImport } from './routes/admin/finance'
import { Route as GuestsRouteImport } from './routes/admin/guests'
import { Route as HostsRouteImport } from './routes/admin/hosts'
import { Route as OpsRouteImport } from './routes/admin/ops'
import { Route as WebhooksRouteImport } from './routes/admin/webhooks'
import { Route as ApprovalsIndexRouteImport } from './routes/admin/approvals.index'
import { Route as ApprovalsIdRouteImport } from './routes/admin/approvals.$id'
import { Route as BookingsIndexRouteImport } from './routes/admin/bookings.index'
import { Route as BookingsIdRouteImport } from './routes/admin/bookings.$id'
import { Route as GuestsIndexRouteImport } from './routes/admin/guests.index'
import { Route as GuestsIdRouteImport } from './routes/admin/guests.$id'
import { Route as HostsIndexRouteImport } from './routes/admin/hosts.index'
import { Route as HostsIdRouteImport } from './routes/admin/hosts.$id'
import { Route as SignInIndexRouteImport } from './routes/admin/sign-in.index'
import { Route as SignInMfaRouteImport } from './routes/admin/sign-in.mfa'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsRoute = BookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentRoute = ContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestsRoute = GuestsRouteImport.update({
  id: '/guests',
  path: '/guests',
  getParentRoute: () => rootRouteImport,
} as any)
const HostsRoute = HostsRouteImport.update({
  id: '/hosts',
  path: '/hosts',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksRoute = WebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsIndexRoute = ApprovalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApprovalsRoute,
} as any)
const ApprovalsIdRoute = ApprovalsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ApprovalsRoute,
} as any)
const BookingsIndexRoute = BookingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BookingsRoute,
} as any)
const BookingsIdRoute = BookingsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BookingsRoute,
} as any)
const GuestsIndexRoute = GuestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuestsRoute,
} as any)
const GuestsIdRoute = GuestsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => GuestsRoute,
} as any)
const HostsIndexRoute = HostsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HostsRoute,
} as any)
const HostsIdRoute = HostsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => HostsRoute,
} as any)
const SignInIndexRoute = SignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInMfaRoute = SignInMfaRouteImport.update({
  id: '/sign-in/mfa',
  path: '/sign-in/mfa',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/approvals': typeof ApprovalsRouteWithChildren
  '/bookings': typeof BookingsRouteWithChildren
  '/content': typeof ContentRoute
  '/finance': typeof FinanceRoute
  '/guests': typeof GuestsRouteWithChildren
  '/hosts': typeof HostsRouteWithChildren
  '/ops': typeof OpsRoute
  '/webhooks': typeof WebhooksRoute
  '/approvals/$id': typeof ApprovalsIdRoute
  '/bookings/$id': typeof BookingsIdRoute
  '/guests/$id': typeof GuestsIdRoute
  '/hosts/$id': typeof HostsIdRoute
  '/sign-in/mfa': typeof SignInMfaRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/bookings/': typeof BookingsIndexRoute
  '/guests/': typeof GuestsIndexRoute
  '/hosts/': typeof HostsIndexRoute
  '/sign-in/': typeof SignInIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/content': typeof ContentRoute
  '/finance': typeof FinanceRoute
  '/ops': typeof OpsRoute
  '/webhooks': typeof WebhooksRoute
  '/approvals/$id': typeof ApprovalsIdRoute
  '/bookings/$id': typeof BookingsIdRoute
  '/guests/$id': typeof GuestsIdRoute
  '/hosts/$id': typeof HostsIdRoute
  '/sign-in/mfa': typeof SignInMfaRoute
  '/approvals': typeof ApprovalsIndexRoute
  '/bookings': typeof BookingsIndexRoute
  '/guests': typeof GuestsIndexRoute
  '/hosts': typeof HostsIndexRoute
  '/sign-in': typeof SignInIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/approvals': typeof ApprovalsRouteWithChildren
  '/bookings': typeof BookingsRouteWithChildren
  '/content': typeof ContentRoute
  '/finance': typeof FinanceRoute
  '/guests': typeof GuestsRouteWithChildren
  '/hosts': typeof HostsRouteWithChildren
  '/ops': typeof OpsRoute
  '/webhooks': typeof WebhooksRoute
  '/approvals/$id': typeof ApprovalsIdRoute
  '/bookings/$id': typeof BookingsIdRoute
  '/guests/$id': typeof GuestsIdRoute
  '/hosts/$id': typeof HostsIdRoute
  '/sign-in/mfa': typeof SignInMfaRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/bookings/': typeof BookingsIndexRoute
  '/guests/': typeof GuestsIndexRoute
  '/hosts/': typeof HostsIndexRoute
  '/sign-in/': typeof SignInIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/approvals'
    | '/bookings'
    | '/content'
    | '/finance'
    | '/guests'
    | '/hosts'
    | '/ops'
    | '/webhooks'
    | '/approvals/$id'
    | '/bookings/$id'
    | '/guests/$id'
    | '/hosts/$id'
    | '/sign-in/mfa'
    | '/approvals/'
    | '/bookings/'
    | '/guests/'
    | '/hosts/'
    | '/sign-in/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/content'
    | '/finance'
    | '/ops'
    | '/webhooks'
    | '/approvals/$id'
    | '/bookings/$id'
    | '/guests/$id'
    | '/hosts/$id'
    | '/sign-in/mfa'
    | '/approvals'
    | '/bookings'
    | '/guests'
    | '/hosts'
    | '/sign-in'
  id:
    | '__root__'
    | '/'
    | '/approvals'
    | '/bookings'
    | '/content'
    | '/finance'
    | '/guests'
    | '/hosts'
    | '/ops'
    | '/webhooks'
    | '/approvals/$id'
    | '/bookings/$id'
    | '/guests/$id'
    | '/hosts/$id'
    | '/sign-in/mfa'
    | '/approvals/'
    | '/bookings/'
    | '/guests/'
    | '/hosts/'
    | '/sign-in/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApprovalsRoute: typeof ApprovalsRouteWithChildren
  BookingsRoute: typeof BookingsRouteWithChildren
  ContentRoute: typeof ContentRoute
  FinanceRoute: typeof FinanceRoute
  GuestsRoute: typeof GuestsRouteWithChildren
  HostsRoute: typeof HostsRouteWithChildren
  OpsRoute: typeof OpsRoute
  WebhooksRoute: typeof WebhooksRoute
  SignInMfaRoute: typeof SignInMfaRoute
  SignInIndexRoute: typeof SignInIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content': {
      id: '/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof ContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guests': {
      id: '/guests'
      path: '/guests'
      fullPath: '/guests'
      preLoaderRoute: typeof GuestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hosts': {
      id: '/hosts'
      path: '/hosts'
      fullPath: '/hosts'
      preLoaderRoute: typeof HostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops': {
      id: '/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof OpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks': {
      id: '/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof WebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals/': {
      id: '/approvals/'
      path: '/'
      fullPath: '/approvals/'
      preLoaderRoute: typeof ApprovalsIndexRouteImport
      parentRoute: typeof ApprovalsRoute
    }
    '/approvals/$id': {
      id: '/approvals/$id'
      path: '/$id'
      fullPath: '/approvals/$id'
      preLoaderRoute: typeof ApprovalsIdRouteImport
      parentRoute: typeof ApprovalsRoute
    }
    '/bookings/': {
      id: '/bookings/'
      path: '/'
      fullPath: '/bookings/'
      preLoaderRoute: typeof BookingsIndexRouteImport
      parentRoute: typeof BookingsRoute
    }
    '/bookings/$id': {
      id: '/bookings/$id'
      path: '/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof BookingsIdRouteImport
      parentRoute: typeof BookingsRoute
    }
    '/guests/': {
      id: '/guests/'
      path: '/'
      fullPath: '/guests/'
      preLoaderRoute: typeof GuestsIndexRouteImport
      parentRoute: typeof GuestsRoute
    }
    '/guests/$id': {
      id: '/guests/$id'
      path: '/$id'
      fullPath: '/guests/$id'
      preLoaderRoute: typeof GuestsIdRouteImport
      parentRoute: typeof GuestsRoute
    }
    '/hosts/': {
      id: '/hosts/'
      path: '/'
      fullPath: '/hosts/'
      preLoaderRoute: typeof HostsIndexRouteImport
      parentRoute: typeof HostsRoute
    }
    '/hosts/$id': {
      id: '/hosts/$id'
      path: '/$id'
      fullPath: '/hosts/$id'
      preLoaderRoute: typeof HostsIdRouteImport
      parentRoute: typeof HostsRoute
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof SignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/mfa': {
      id: '/sign-in/mfa'
      path: '/sign-in/mfa'
      fullPath: '/sign-in/mfa'
      preLoaderRoute: typeof SignInMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ApprovalsRouteChildren {
  ApprovalsIdRoute: typeof ApprovalsIdRoute
  ApprovalsIndexRoute: typeof ApprovalsIndexRoute
}

const ApprovalsRouteChildren: ApprovalsRouteChildren = {
  ApprovalsIdRoute: ApprovalsIdRoute,
  ApprovalsIndexRoute: ApprovalsIndexRoute,
}

const ApprovalsRouteWithChildren = ApprovalsRoute._addFileChildren(
  ApprovalsRouteChildren,
)

interface BookingsRouteChildren {
  BookingsIdRoute: typeof BookingsIdRoute
  BookingsIndexRoute: typeof BookingsIndexRoute
}

const BookingsRouteChildren: BookingsRouteChildren = {
  BookingsIdRoute: BookingsIdRoute,
  BookingsIndexRoute: BookingsIndexRoute,
}

const BookingsRouteWithChildren = BookingsRoute._addFileChildren(
  BookingsRouteChildren,
)

interface GuestsRouteChildren {
  GuestsIdRoute: typeof GuestsIdRoute
  GuestsIndexRoute: typeof GuestsIndexRoute
}

const GuestsRouteChildren: GuestsRouteChildren = {
  GuestsIdRoute: GuestsIdRoute,
  GuestsIndexRoute: GuestsIndexRoute,
}

const GuestsRouteWithChildren =
  GuestsRoute._addFileChildren(GuestsRouteChildren)

interface HostsRouteChildren {
  HostsIdRoute: typeof HostsIdRoute
  HostsIndexRoute: typeof HostsIndexRoute
}

const HostsRouteChildren: HostsRouteChildren = {
  HostsIdRoute: HostsIdRoute,
  HostsIndexRoute: HostsIndexRoute,
}

const HostsRouteWithChildren = HostsRoute._addFileChildren(HostsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApprovalsRoute: ApprovalsRouteWithChildren,
  BookingsRoute: BookingsRouteWithChildren,
  ContentRoute: ContentRoute,
  FinanceRoute: FinanceRoute,
  GuestsRoute: GuestsRouteWithChildren,
  HostsRoute: HostsRouteWithChildren,
  OpsRoute: OpsRoute,
  WebhooksRoute: WebhooksRoute,
  SignInMfaRoute: SignInMfaRoute,
  SignInIndexRoute: SignInIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
